import { NgModule } from '@angular/core';
import { Ng2PaginationModule } from 'ng2-pagination';
import { ReactiveFormsModule } from '@angular/forms';
import { Ng2DatetimePickerModule } from 'ng2-datetime-picker';
import { Ng2AutoCompleteModule } from 'ng2-auto-complete';

import { CampaignsComponent } from './campaigns.component';
import { SharedModule } from "../shared/shared.module";
import { CommonModule } from "@angular/common";
import { CampaignsFilterComponent } from "./campaigns-filter.component";
import { CampaignDetailsComponent } from './campaign-details.component';
import { PublisherAllocationComponent } from './publisher-allocation-modal.component';
import { PpaComponent } from './ppa-modal.component';
import { CampaignsService } from "./campaigns.service";
import { FormsModule } from '@angular/forms';
import { RouterModule } from "@angular/router";

@NgModule({
    imports: [CommonModule, SharedModule, FormsModule, Ng2PaginationModule, ReactiveFormsModule, Ng2DatetimePickerModule, Ng2AutoCompleteModule, RouterModule],
    exports: [],
    declarations: [CampaignsComponent, CampaignsFilterComponent, CampaignDetailsComponent, PublisherAllocationComponent, PpaComponent],
    providers: [CampaignsService],
})
export class CampaignsModule { }



// WEBPACK FOOTER //
// ./src/app/campaigns/campaigns.module.ts